export default __webpack_public_path__ + "static/media/committee-zhang.603e3f2c.png";